import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, renderNothing, branch, withState } from 'recompose'
import { TINY_EDITOR_SCRIPT_URL } from 'constants/ResourcesConstants'
import { hasMeetings } from 'app/modules/gates/selectors'

import * as PlaybookActions from 'app/modules/playbook/actions'
import { getIsVidyardEnabled } from 'app/modules/org/selectors'

import TinyEditor from './component'

const mapStateToProps = state => ({
  hasMeetings: hasMeetings(state),
  isVidyardEnabled: getIsVidyardEnabled(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      showTokenModal: PlaybookActions.showTokenModal,
      showCalendarLinkModal: PlaybookActions.showCalendarLinkModal,
      showCtaButtonModal: PlaybookActions.showCtaButtonModal,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('editorLibLoaded', 'setEditorLibLoaded', !!window.tinymce),
  withState('vidyardModalOpen', 'setVidyardModalOpen', false),
  lifecycle({
    componentDidMount() {
      if (!this.props.editorLibLoaded && !document.getElementById('tinyEditorInjection')) {
        const tinyScript = document.createElement('script')
        tinyScript.setAttribute('id', 'tinyEditorInjection')
        tinyScript.setAttribute('src', TINY_EDITOR_SCRIPT_URL)
        document.body.appendChild(tinyScript)
      }
      this.props.setEditorLibLoaded(!!window.tinymce)
    },
    componentWillReceiveProps() {
      const { editorLibLoaded, setEditorLibLoaded } = this.props
      if (!editorLibLoaded) {
        setTimeout(() => {
          setEditorLibLoaded(!!window.tinymce)
        }, 100)
      }
    },
  }),
  branch(() => !window.tinymce, renderNothing),
  withHandlers({
    showTokenPicker: props => () => {
      props.actions.showTokenModal()
    },
    showCalendarLinkPicker: props => () => {
      props.actions.showCalendarLinkModal()
    },
  })
)(TinyEditor)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TinyEditor/index.js